import {Department} from '../../../profile/types';

export interface WorkforceDepartmentOption {
  resourceId: string;
  label: string;
}

export const flattenWorkforceDepartmentOptions = (
  departments: Department[],
  currentLanguage: 'en' | 'de'
): WorkforceDepartmentOption[] => {
  return departments.flatMap((department) => {
    const departmentLabel = department.name[currentLanguage];
    const subdepartments = department.subdepartments ?? department.subDepartments ?? [];

    return [
      {resourceId: department.resourceId, label: departmentLabel},
      ...subdepartments.map((subdepartment) => ({
        resourceId: subdepartment.resourceId,
        label: `${departmentLabel} / ${subdepartment.name[currentLanguage]}`,
      })),
    ];
  });
};
